"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetAmountState = exports.LiquidValidatorState = exports.LiquidValidator = exports.WhitelistedValidator = exports.Params = exports.validatorStatusToJSON = exports.validatorStatusFromJSON = exports.ValidatorStatus = exports.protobufPackage = void 0;
/* eslint-disable */
const binary_1 = require("../../../binary");
const helpers_1 = require("../../../helpers");
exports.protobufPackage = "pstake.liquidstake.v1beta1";
/** ValidatorStatus enumerates the status of a liquid validator. */
var ValidatorStatus;
(function (ValidatorStatus) {
    /** VALIDATOR_STATUS_UNSPECIFIED - VALIDATOR_STATUS_UNSPECIFIED defines the unspecified invalid status. */
    ValidatorStatus[ValidatorStatus["VALIDATOR_STATUS_UNSPECIFIED"] = 0] = "VALIDATOR_STATUS_UNSPECIFIED";
    /** VALIDATOR_STATUS_ACTIVE - VALIDATOR_STATUS_ACTIVE defines the active, valid status */
    ValidatorStatus[ValidatorStatus["VALIDATOR_STATUS_ACTIVE"] = 1] = "VALIDATOR_STATUS_ACTIVE";
    /** VALIDATOR_STATUS_INACTIVE - VALIDATOR_STATUS_INACTIVE defines the inactive, invalid status */
    ValidatorStatus[ValidatorStatus["VALIDATOR_STATUS_INACTIVE"] = 2] = "VALIDATOR_STATUS_INACTIVE";
    ValidatorStatus[ValidatorStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ValidatorStatus = exports.ValidatorStatus || (exports.ValidatorStatus = {}));
function validatorStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "VALIDATOR_STATUS_UNSPECIFIED":
            return ValidatorStatus.VALIDATOR_STATUS_UNSPECIFIED;
        case 1:
        case "VALIDATOR_STATUS_ACTIVE":
            return ValidatorStatus.VALIDATOR_STATUS_ACTIVE;
        case 2:
        case "VALIDATOR_STATUS_INACTIVE":
            return ValidatorStatus.VALIDATOR_STATUS_INACTIVE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ValidatorStatus.UNRECOGNIZED;
    }
}
exports.validatorStatusFromJSON = validatorStatusFromJSON;
function validatorStatusToJSON(object) {
    switch (object) {
        case ValidatorStatus.VALIDATOR_STATUS_UNSPECIFIED:
            return "VALIDATOR_STATUS_UNSPECIFIED";
        case ValidatorStatus.VALIDATOR_STATUS_ACTIVE:
            return "VALIDATOR_STATUS_ACTIVE";
        case ValidatorStatus.VALIDATOR_STATUS_INACTIVE:
            return "VALIDATOR_STATUS_INACTIVE";
        case ValidatorStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.validatorStatusToJSON = validatorStatusToJSON;
function createBaseParams() {
    return {
        liquidBondDenom: "",
        whitelistedValidators: [],
        unstakeFeeRate: "",
        lsmDisabled: false,
        minLiquidStakeAmount: "",
        cwLockedPoolAddress: "",
        feeAccountAddress: "",
        autocompoundFeeRate: "",
        whitelistAdminAddress: "",
        modulePaused: false,
    };
}
exports.Params = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.liquidBondDenom !== "") {
            writer.uint32(10).string(message.liquidBondDenom);
        }
        for (const v of message.whitelistedValidators) {
            exports.WhitelistedValidator.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.unstakeFeeRate !== "") {
            writer.uint32(26).string(message.unstakeFeeRate);
        }
        if (message.lsmDisabled === true) {
            writer.uint32(32).bool(message.lsmDisabled);
        }
        if (message.minLiquidStakeAmount !== "") {
            writer.uint32(42).string(message.minLiquidStakeAmount);
        }
        if (message.cwLockedPoolAddress !== "") {
            writer.uint32(50).string(message.cwLockedPoolAddress);
        }
        if (message.feeAccountAddress !== "") {
            writer.uint32(58).string(message.feeAccountAddress);
        }
        if (message.autocompoundFeeRate !== "") {
            writer.uint32(66).string(message.autocompoundFeeRate);
        }
        if (message.whitelistAdminAddress !== "") {
            writer.uint32(74).string(message.whitelistAdminAddress);
        }
        if (message.modulePaused === true) {
            writer.uint32(80).bool(message.modulePaused);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.liquidBondDenom = reader.string();
                    break;
                case 2:
                    message.whitelistedValidators.push(exports.WhitelistedValidator.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.unstakeFeeRate = reader.string();
                    break;
                case 4:
                    message.lsmDisabled = reader.bool();
                    break;
                case 5:
                    message.minLiquidStakeAmount = reader.string();
                    break;
                case 6:
                    message.cwLockedPoolAddress = reader.string();
                    break;
                case 7:
                    message.feeAccountAddress = reader.string();
                    break;
                case 8:
                    message.autocompoundFeeRate = reader.string();
                    break;
                case 9:
                    message.whitelistAdminAddress = reader.string();
                    break;
                case 10:
                    message.modulePaused = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseParams();
        if ((0, helpers_1.isSet)(object.liquidBondDenom))
            obj.liquidBondDenom = String(object.liquidBondDenom);
        if (Array.isArray(object?.whitelistedValidators))
            obj.whitelistedValidators = object.whitelistedValidators.map((e) => exports.WhitelistedValidator.fromJSON(e));
        if ((0, helpers_1.isSet)(object.unstakeFeeRate))
            obj.unstakeFeeRate = String(object.unstakeFeeRate);
        if ((0, helpers_1.isSet)(object.lsmDisabled))
            obj.lsmDisabled = Boolean(object.lsmDisabled);
        if ((0, helpers_1.isSet)(object.minLiquidStakeAmount))
            obj.minLiquidStakeAmount = String(object.minLiquidStakeAmount);
        if ((0, helpers_1.isSet)(object.cwLockedPoolAddress))
            obj.cwLockedPoolAddress = String(object.cwLockedPoolAddress);
        if ((0, helpers_1.isSet)(object.feeAccountAddress))
            obj.feeAccountAddress = String(object.feeAccountAddress);
        if ((0, helpers_1.isSet)(object.autocompoundFeeRate))
            obj.autocompoundFeeRate = String(object.autocompoundFeeRate);
        if ((0, helpers_1.isSet)(object.whitelistAdminAddress))
            obj.whitelistAdminAddress = String(object.whitelistAdminAddress);
        if ((0, helpers_1.isSet)(object.modulePaused))
            obj.modulePaused = Boolean(object.modulePaused);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.liquidBondDenom !== undefined && (obj.liquidBondDenom = message.liquidBondDenom);
        if (message.whitelistedValidators) {
            obj.whitelistedValidators = message.whitelistedValidators.map((e) => e ? exports.WhitelistedValidator.toJSON(e) : undefined);
        }
        else {
            obj.whitelistedValidators = [];
        }
        message.unstakeFeeRate !== undefined && (obj.unstakeFeeRate = message.unstakeFeeRate);
        message.lsmDisabled !== undefined && (obj.lsmDisabled = message.lsmDisabled);
        message.minLiquidStakeAmount !== undefined && (obj.minLiquidStakeAmount = message.minLiquidStakeAmount);
        message.cwLockedPoolAddress !== undefined && (obj.cwLockedPoolAddress = message.cwLockedPoolAddress);
        message.feeAccountAddress !== undefined && (obj.feeAccountAddress = message.feeAccountAddress);
        message.autocompoundFeeRate !== undefined && (obj.autocompoundFeeRate = message.autocompoundFeeRate);
        message.whitelistAdminAddress !== undefined &&
            (obj.whitelistAdminAddress = message.whitelistAdminAddress);
        message.modulePaused !== undefined && (obj.modulePaused = message.modulePaused);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.liquidBondDenom = object.liquidBondDenom ?? "";
        message.whitelistedValidators =
            object.whitelistedValidators?.map((e) => exports.WhitelistedValidator.fromPartial(e)) || [];
        message.unstakeFeeRate = object.unstakeFeeRate ?? "";
        message.lsmDisabled = object.lsmDisabled ?? false;
        message.minLiquidStakeAmount = object.minLiquidStakeAmount ?? "";
        message.cwLockedPoolAddress = object.cwLockedPoolAddress ?? "";
        message.feeAccountAddress = object.feeAccountAddress ?? "";
        message.autocompoundFeeRate = object.autocompoundFeeRate ?? "";
        message.whitelistAdminAddress = object.whitelistAdminAddress ?? "";
        message.modulePaused = object.modulePaused ?? false;
        return message;
    },
};
function createBaseWhitelistedValidator() {
    return {
        validatorAddress: "",
        targetWeight: "",
    };
}
exports.WhitelistedValidator = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        if (message.targetWeight !== "") {
            writer.uint32(18).string(message.targetWeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWhitelistedValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.targetWeight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseWhitelistedValidator();
        if ((0, helpers_1.isSet)(object.validatorAddress))
            obj.validatorAddress = String(object.validatorAddress);
        if ((0, helpers_1.isSet)(object.targetWeight))
            obj.targetWeight = String(object.targetWeight);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.targetWeight !== undefined && (obj.targetWeight = message.targetWeight);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseWhitelistedValidator();
        message.validatorAddress = object.validatorAddress ?? "";
        message.targetWeight = object.targetWeight ?? "";
        return message;
    },
};
function createBaseLiquidValidator() {
    return {
        operatorAddress: "",
    };
}
exports.LiquidValidator = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.operatorAddress !== "") {
            writer.uint32(10).string(message.operatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLiquidValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseLiquidValidator();
        if ((0, helpers_1.isSet)(object.operatorAddress))
            obj.operatorAddress = String(object.operatorAddress);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseLiquidValidator();
        message.operatorAddress = object.operatorAddress ?? "";
        return message;
    },
};
function createBaseLiquidValidatorState() {
    return {
        operatorAddress: "",
        weight: "",
        status: 0,
        delShares: "",
        liquidTokens: "",
    };
}
exports.LiquidValidatorState = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.operatorAddress !== "") {
            writer.uint32(10).string(message.operatorAddress);
        }
        if (message.weight !== "") {
            writer.uint32(18).string(message.weight);
        }
        if (message.status !== 0) {
            writer.uint32(24).int32(message.status);
        }
        if (message.delShares !== "") {
            writer.uint32(34).string(message.delShares);
        }
        if (message.liquidTokens !== "") {
            writer.uint32(42).string(message.liquidTokens);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLiquidValidatorState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.delShares = reader.string();
                    break;
                case 5:
                    message.liquidTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseLiquidValidatorState();
        if ((0, helpers_1.isSet)(object.operatorAddress))
            obj.operatorAddress = String(object.operatorAddress);
        if ((0, helpers_1.isSet)(object.weight))
            obj.weight = String(object.weight);
        if ((0, helpers_1.isSet)(object.status))
            obj.status = validatorStatusFromJSON(object.status);
        if ((0, helpers_1.isSet)(object.delShares))
            obj.delShares = String(object.delShares);
        if ((0, helpers_1.isSet)(object.liquidTokens))
            obj.liquidTokens = String(object.liquidTokens);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.weight !== undefined && (obj.weight = message.weight);
        message.status !== undefined && (obj.status = validatorStatusToJSON(message.status));
        message.delShares !== undefined && (obj.delShares = message.delShares);
        message.liquidTokens !== undefined && (obj.liquidTokens = message.liquidTokens);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseLiquidValidatorState();
        message.operatorAddress = object.operatorAddress ?? "";
        message.weight = object.weight ?? "";
        message.status = object.status ?? 0;
        message.delShares = object.delShares ?? "";
        message.liquidTokens = object.liquidTokens ?? "";
        return message;
    },
};
function createBaseNetAmountState() {
    return {
        mintRate: "",
        stkxprtTotalSupply: "",
        netAmount: "",
        totalDelShares: "",
        totalLiquidTokens: "",
        totalRemainingRewards: "",
        totalUnbondingBalance: "",
        proxyAccBalance: "",
    };
}
exports.NetAmountState = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.mintRate !== "") {
            writer.uint32(10).string(message.mintRate);
        }
        if (message.stkxprtTotalSupply !== "") {
            writer.uint32(18).string(message.stkxprtTotalSupply);
        }
        if (message.netAmount !== "") {
            writer.uint32(26).string(message.netAmount);
        }
        if (message.totalDelShares !== "") {
            writer.uint32(34).string(message.totalDelShares);
        }
        if (message.totalLiquidTokens !== "") {
            writer.uint32(42).string(message.totalLiquidTokens);
        }
        if (message.totalRemainingRewards !== "") {
            writer.uint32(50).string(message.totalRemainingRewards);
        }
        if (message.totalUnbondingBalance !== "") {
            writer.uint32(58).string(message.totalUnbondingBalance);
        }
        if (message.proxyAccBalance !== "") {
            writer.uint32(66).string(message.proxyAccBalance);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNetAmountState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mintRate = reader.string();
                    break;
                case 2:
                    message.stkxprtTotalSupply = reader.string();
                    break;
                case 3:
                    message.netAmount = reader.string();
                    break;
                case 4:
                    message.totalDelShares = reader.string();
                    break;
                case 5:
                    message.totalLiquidTokens = reader.string();
                    break;
                case 6:
                    message.totalRemainingRewards = reader.string();
                    break;
                case 7:
                    message.totalUnbondingBalance = reader.string();
                    break;
                case 8:
                    message.proxyAccBalance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseNetAmountState();
        if ((0, helpers_1.isSet)(object.mintRate))
            obj.mintRate = String(object.mintRate);
        if ((0, helpers_1.isSet)(object.stkxprtTotalSupply))
            obj.stkxprtTotalSupply = String(object.stkxprtTotalSupply);
        if ((0, helpers_1.isSet)(object.netAmount))
            obj.netAmount = String(object.netAmount);
        if ((0, helpers_1.isSet)(object.totalDelShares))
            obj.totalDelShares = String(object.totalDelShares);
        if ((0, helpers_1.isSet)(object.totalLiquidTokens))
            obj.totalLiquidTokens = String(object.totalLiquidTokens);
        if ((0, helpers_1.isSet)(object.totalRemainingRewards))
            obj.totalRemainingRewards = String(object.totalRemainingRewards);
        if ((0, helpers_1.isSet)(object.totalUnbondingBalance))
            obj.totalUnbondingBalance = String(object.totalUnbondingBalance);
        if ((0, helpers_1.isSet)(object.proxyAccBalance))
            obj.proxyAccBalance = String(object.proxyAccBalance);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.mintRate !== undefined && (obj.mintRate = message.mintRate);
        message.stkxprtTotalSupply !== undefined && (obj.stkxprtTotalSupply = message.stkxprtTotalSupply);
        message.netAmount !== undefined && (obj.netAmount = message.netAmount);
        message.totalDelShares !== undefined && (obj.totalDelShares = message.totalDelShares);
        message.totalLiquidTokens !== undefined && (obj.totalLiquidTokens = message.totalLiquidTokens);
        message.totalRemainingRewards !== undefined &&
            (obj.totalRemainingRewards = message.totalRemainingRewards);
        message.totalUnbondingBalance !== undefined &&
            (obj.totalUnbondingBalance = message.totalUnbondingBalance);
        message.proxyAccBalance !== undefined && (obj.proxyAccBalance = message.proxyAccBalance);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseNetAmountState();
        message.mintRate = object.mintRate ?? "";
        message.stkxprtTotalSupply = object.stkxprtTotalSupply ?? "";
        message.netAmount = object.netAmount ?? "";
        message.totalDelShares = object.totalDelShares ?? "";
        message.totalLiquidTokens = object.totalLiquidTokens ?? "";
        message.totalRemainingRewards = object.totalRemainingRewards ?? "";
        message.totalUnbondingBalance = object.totalUnbondingBalance ?? "";
        message.proxyAccBalance = object.proxyAccBalance ?? "";
        return message;
    },
};
//# sourceMappingURL=liquidstake.js.map